import { User } from 'classes/user';
import { LocalStorage } from 'libs/common';

export const user = new User({ storage: new LocalStorage('api') });
